import { Suspense } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';
import { usePageViewTracking } from '../hooks/analytics/use-page-view-tracking';
import { AnonymousCookieBar } from './anonymous-cookie-bar';
import { FullScreenSpinner } from './full-screen-spinner';
import { NavigationProgress } from './navigation-progress';

export function RootLayout() {
  // Mounted here, not in MainLayout, so the signed-out routes (sign-in, sign-up,
  // invite, accept-terms) are measured too.
  usePageViewTracking();

  return (
    <>
      <NavigationProgress />
      <ScrollRestoration />
      {/* Boundary di sicurezza top-level: sta FUORI dallo shell (route pubbliche
          come sign-in/privacy/public/*) dove non esiste chrome da preservare,
          quindi full-screen è corretto. Per le route protette la boundary più
          vicina è quella dello shell (ContentAreaSpinner in MainLayout) e vince
          la nearest-boundary rule: questo fallback resta l'ultima rete. */}
      <Suspense fallback={<FullScreenSpinner />}>
        <Outlet />
      </Suspense>
      <AnonymousCookieBar />
    </>
  );
}
